export default "<p style=\"position:fixed;top:0px;background: red;z-index:400;wisth:100px;height: 100px;;\">\n  slide-demo works!\n</p>\n";